
import Keywords from '@/components/Keywords';
import VuePlyr from 'vue-plyr/dist/vue-plyr.ssr.js';
import 'plyr/dist/plyr.css';

export default {
  components: {
    Keywords,
    VuePlyr,
  },
  async asyncData({ $content }) {
    return { damien: await $content('damien').fetch() };
  },
  data() {
    return { damien: {} };
  },
  head() {
    return {
      script: [
        {
          json: this.damien,
          type: 'application/ld+json',
        },
        {
          async: '',
          src: 'https://static.addtoany.com/menu/page.js',
        },
      ],
    };
  },
};
